import sessionService from '../services/sessionService';

let heartbeatTimer = null;
let isInitialized = false;

const HEARTBEAT_INTERVAL_MS = 30 * 1000; // 30 seconds

const onVisibilityChange = () => {
  if (typeof document !== 'undefined' && document.visibilityState === 'visible') {
    const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
    if (token) {
      sessionService.sendHeartbeat();
    }
  }
};

const onPageHide = () => {
  sessionService.sendCloseBeacon();
};

export function startSessionPresence() {
  if (typeof window === 'undefined' || isInitialized) return;
  isInitialized = true;

  // Initial heartbeat if already logged in
  const token = localStorage.getItem('token');
  if (token) {
    sessionService.sendHeartbeat();
  }

  // Periodic heartbeat
  if (!heartbeatTimer) {
    heartbeatTimer = setInterval(() => {
      const activeToken = localStorage.getItem('token');
      if (activeToken && typeof document !== 'undefined' && document.visibilityState === 'visible') {
        sessionService.sendHeartbeat();
      }
    }, HEARTBEAT_INTERVAL_MS);
  }

  // Reactivate session when tab gains focus / visibility
  document.addEventListener('visibilitychange', onVisibilityChange);

  // Close session beacon on tab/window close
  window.addEventListener('pagehide', onPageHide);
  window.addEventListener('beforeunload', onPageHide);
}

export function stopSessionPresence() {
  if (heartbeatTimer) {
    clearInterval(heartbeatTimer);
    heartbeatTimer = null;
  }
  if (typeof document !== 'undefined') {
    document.removeEventListener('visibilitychange', onVisibilityChange);
  }
  if (typeof window !== 'undefined') {
    window.removeEventListener('pagehide', onPageHide);
    window.removeEventListener('beforeunload', onPageHide);
  }
  isInitialized = false;
}
